<script>
    import { onMount } from 'svelte';
    
    export let selectedDate = new Date();
    let months = [];

    const today = new Date();
  
    // Function to get the days of a month
    function getDaysInMonth(year, month) {
      let date = new Date(year, month, 1);
      let days = [];
      while (date.getMonth() === month) {
        days.push(new Date(date));
        date.setDate(date.getDate() + 1);
      }
      return days;
    }
  
    // Generate calendar data for the three months
    function generateMonths() {
      let currentDate = new Date();
      months = [
        { name: currentDate.toLocaleString('cs-CZ', { month: 'long' }), days: getDaysInMonth(currentDate.getFullYear(), currentDate.getMonth()) },
        { name: new Date(currentDate.getFullYear(), currentDate.getMonth() + 1).toLocaleString('cs-CZ', { month: 'long' }), days: getDaysInMonth(currentDate.getFullYear(), currentDate.getMonth() + 1) },
        { name: new Date(currentDate.getFullYear(), currentDate.getMonth() + 2).toLocaleString('cs-CZ', { month: 'long' }), days: getDaysInMonth(currentDate.getFullYear(), currentDate.getMonth() + 2) }
      ];
    }
  
    // Call the function on component mount
    onMount(() => {
      generateMonths();
    });
  
    // Function to select a date
    function selectDate(date) {
      if (date.getTime() >= today.setHours(0, 0, 0, 0)) { 
        // Zkontrolujeme, jestli je den v minulosti
        selectedDate = date;
      }
      console.log(selectedDate);
    }
  
  </script>
  
  <style>
    .calendar-container {
      display: flex;
      justify-content: space-around;
    }
  
    .calendar {
      width: 150px;
    }
  
    .calendar-header {
      text-align: center;
      font-weight: bold;
    }
  
    .calendar-grid {
        display: grid;
        grid-template-columns: repeat(7, 1fr);
        gap: 5px;
    }

    .day {
      display: inline-block;
      width: 20px;
      height: 20px;
      text-align: center;
      line-height: 20px;
      margin: 2px;
      cursor: pointer;
    }
  
    .day.selected {
      background-color: #007bff;
      color: white;
      border-radius: 25%;
      font-weight: bolder;
    }
  
    .day:not(.selected):hover {
      background-color: #ddd;
      border-radius: 25%;
    }
  
    .empty-day {
      display: inline-block;
      width: 20px;
      height: 20px;
      margin: 2px;
    }

    div.disabled {
      color: #c1c1c1 !important;
    }
  </style>
  
  <div class="calendar-container">
    {#each months as month}
      <div class="calendar">
        <div class="calendar-header">{month.name}</div>
        <div class="calendar-grid">
          {#each ['Po', 'Út', 'St', 'Čt', 'Pá', 'So', 'Ne'] as dayOfWeek}
            <div class="day-name">{dayOfWeek}</div>
          {/each}
          {#each Array((month.days[0].getDay() + 6) % 7).fill('') as _}
            <div class="empty-day"></div>
          {/each}
          {#each month.days as day}
            <div 
              class="day {selectedDate && selectedDate.getTime() === day.getTime() ? 'selected' : ''}" 
              class:disabled={day.getTime() < (new Date()).setHours(0, 0, 0, 0)}
              on:click={() => selectDate(day)}>
              {day.getDate()}
            </div>
          {/each}
        </div>
      </div>
    {/each}
  </div>
  